export const all = ['publicTrips'] as const
export const details = [...all, 'details'] as const
export const detail = (id: string) => [...details, id] as const
export const userOwnsTrip = (id: string, ownsTrip: boolean) =>
  [...detail(id), ownsTrip] as const
export const publicTripId = (id: string) => [...detail(id), 'publicId', id]
